import React, {Component} from 'react'
import Skeleton from 'react-loading-skeleton';

export default class ApartmentCarouselImage extends Component {
    state = {
        imageLoaded: false
    }

    handleLoad = () => {
        this.setState({
            imageLoaded: true
        })
    }

    render() {
        const {href, uri, title} = this.props;

        return (
            <div style={{position: 'relative'}}>
                {!this.state.imageLoaded &&
                <div className="apartment-photos-carousel__image-placeholder">
                    <Skeleton/>
                </div>
                }
                <a className="apartment-photos-carousel__photo" href={href} target="_blank">
                    <img
                        data-src={uri}
                        alt={title}
                        onLoad={this.handleLoad}
                        loading="lazy"
                        decoding="async"
                    />
                </a>
            </div>
        )
    }
}
